module.exports = __webpack_public_path__ + "61974f557e2f4f7febc398c5629513e1.png";